import { render } from "./ModalQuestionario.vue?vue&type=template&id=c82a70ae&scoped=true"
import script from "./ModalQuestionario.vue?vue&type=script&lang=js"
export * from "./ModalQuestionario.vue?vue&type=script&lang=js"

import "./ModalQuestionario.vue?vue&type=style&index=0&id=c82a70ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82a70ae"]])

export default __exports__